// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2ty-a","title":"BackImages_title__3y5QK","images":"BackImages_images__2KbEi"};